// TODO this file seems to be the wrong place for this code.
// if there is a better place move this file.
import { deliveryCategory, mixedCategory } from "SCConstants";

const allEqual = <T extends unknown>(a: T[]): boolean =>
  a.every((e) => a[0] === e);

export function getCategory(
  getValues: () => Record<string, { category: string }[]>,
  fieldName: string = "commodities"
) {
  const categoryPerCommodity = getValues()[fieldName]?.map(
    (item: { category: string }) => item.category
  );

  let consumptionCategory;
  if (!categoryPerCommodity || categoryPerCommodity?.length === 0) {
    consumptionCategory = deliveryCategory;
  } else if (allEqual(categoryPerCommodity)) {
    consumptionCategory = categoryPerCommodity[0];
  } else {
    consumptionCategory = mixedCategory;
  }

  return consumptionCategory;
}
